
export const skillData_ = [
  {
    skillIcon: `https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg`,
    name: "React js",
    level: "intermediate",
    desc: "Building dynamic user interfaces with reusable components and efficient state management.",
  },
  {
    skillIcon: `https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original-wordmark.svg`,
    name: "Node js",
    level: "intermediate",
    desc: "Server-side runtime for building fast, scalable network applications.",
  },
  {
    skillIcon: `https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg`,
    name: "TypeScript",
    level: "intermediate",
    desc: "Type-safe JavaScript for building robust, maintainable codebases.",
  },
  {
    skillIcon: `https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg`,
    name: "Tailwind CSS",
    level: "intermediate",
    desc: "Utility-first CSS framework for rapid, custom UI development.",
  },
  {
    skillIcon: `https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mongodb/mongodb-original.svg`,
    name: "MongoDB",
    level: "intermediate",
    desc: "NoSQL database for flexible, document-oriented data storage.",
  },
  {
    skillIcon: `https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mysql/mysql-original-wordmark.svg`,
    name: "MySQL",
    level: "intermediate",
    desc: "Relational database management system for structured data.",
  },
];

export const skillData = [
  {
    _id: "67853d48795aa4d52cd6061e",
    title: "CSS",
    proficiency: "intermediate",
    description:
      "Styling web pages with cascading stylesheets for responsive, visually appealing designs.",
    images:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/css3/css3-original.svg",
    category: "Frontend",
    createdAt: "2025-01-13T16:20:24.576+00:00",
    updatedAt: "2025-01-13T16:20:24.576+00:00",
  },
  {
    _id: "67853f7a795aa4d52cd6062a",
    title: "Next Js",
    proficiency: "expert",
    description:
      "React framework for production-grade server-side rendering and static site generation.",
    images:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nextjs/nextjs-original.svg",
    category: "Frontend",
    createdAt: "2025-01-13T16:29:46.170+00:00",
    updatedAt: "2025-01-13T16:29:46.170+00:00",
  },
  {
    _id: "6786859edc63840a39462447",
    title: "Redux",
    proficiency: "intermediate",
    description:
      "Predictable state container for consistent and maintainable JavaScript application behavior.",
    images:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/redux/redux-original.svg",
    category: "Frontend",
    createdAt: "2025-01-14T15:41:18.200+00:00",
    updatedAt: "2025-01-14T15:41:18.200+00:00",
  },
  {
    _id: "67868a04dc63840a3946245a",
    title: "PHP",
    proficiency: "intermediate",
    description:
      "Server-side scripting language for dynamic web application and backend development.",
    images:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/php/php-original.svg",
    category: "Backend",
    createdAt: "2025-01-14T16:00:04.856+00:00",
    updatedAt: "2025-01-14T16:00:04.856+00:00",
  },
  {
    _id: "67868ad1dc63840a3946245f",
    title: "Git",
    proficiency: "intermediate",
    description:
      "Distributed version control system for tracking changes and collaborating on code.",
    images:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/git/git-plain-wordmark.svg",
    category: "Tools & Platforms",
    createdAt: "2025-01-14T16:03:29.819+00:00",
    updatedAt: "2025-01-14T16:03:29.819+00:00",
  },
  {
    _id: "67734183f70b6164915a6b4d",
    title: "Tailwind CSS",
    proficiency: "intermediate",
    description: "Utility-first CSS framework for rapid, custom UI development with ease.",
    images:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg",
    category: "Frontend",
    createdAt: "2024-12-31T00:57:39.936+00:00",
    updatedAt: "2024-12-31T00:57:39.936+00:00",
  },
  {
    _id: "677341e8f70b6164915a6b51",
    title: "MySQL",
    proficiency: "expert",
    description:
      "Relational database for structured data management and complex query operations.",
    images:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mysql/mysql-original-wordmark.svg",
    category: "Database",
    createdAt: "2024-12-31T00:59:20.951+00:00",
    updatedAt: "2024-12-31T00:59:20.951+00:00",
  },
  {
    _id: "67853eec795aa4d52cd60628",
    title: "JavaScript",
    proficiency: "expert",
    description:
      "Versatile programming language powering dynamic web and server-side applications.",
    images:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/javascript/javascript-original.svg",
    category: "Frontend",
    createdAt: "2025-01-13T16:27:24.682+00:00",
    updatedAt: "2025-01-13T16:27:24.682+00:00",
  },
  {
    _id: "67734087f70b6164915a6b45",
    title: "React Js",
    proficiency: "expert",
    description:
      "Building interactive user interfaces with a component-based architecture and virtual DOM.",
    images:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/react/react-original.svg",
    category: "Frontend",
    createdAt: "2024-12-31T00:53:27.101+00:00",
    updatedAt: "2024-12-31T00:53:27.101+00:00",
  },
  {
    _id: "67853e92795aa4d52cd60626",
    title: "SASS",
    proficiency: "expert",
    description:
      "CSS preprocessor extending stylesheets with variables, mixins, and nested rules.",
    images:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/sass/sass-original.svg",
    category: "Frontend",
    createdAt: "2025-01-13T16:25:54.491+00:00",
    updatedAt: "2025-01-13T16:25:54.491+00:00",
  },
  {
    _id: "678689a4dc63840a39462458",
    title: "Axios",
    proficiency: "intermediate",
    description:
      "Promise-based HTTP client for seamless API communication in browser and Node.js.",
    images:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/axios/axios-plain.svg",
    category: "Tools & Platforms",
    createdAt: "2025-01-14T15:58:28.866+00:00",
    updatedAt: "2025-01-14T15:58:28.866+00:00",
  },
  {
    _id: "67734118f70b6164915a6b49",
    title: "Node js",
    proficiency: "intermediate",
    description:
      "JavaScript runtime for building scalable and high-performance server-side applications.",
    images:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/nodejs/nodejs-original-wordmark.svg",
    category: "Backend",
    createdAt: "2024-12-31T00:55:52.211+00:00",
    updatedAt: "2024-12-31T00:55:52.211+00:00",
  },
  {
    _id: "67734153f70b6164915a6b4b",
    title: "TypeScript",
    proficiency: "expert",
    description: "Typed superset of JavaScript for improved tooling, scalability, and reliability.",
    images:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/typescript/typescript-original.svg",
    category: "Frontend",
    createdAt: "2024-12-31T00:56:51.695+00:00",
    updatedAt: "2024-12-31T00:56:51.695+00:00",
  },
  {
    _id: "677341b1f70b6164915a6b4f",
    title: "MongoDB",
    proficiency: "expert",
    description:
      "Flexible NoSQL database for scalable, document-oriented data storage and retrieval.",
    images:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/mongodb/mongodb-original.svg",
    category: "Database",
    createdAt: "2024-12-31T00:58:25.064+00:00",
    updatedAt: "2024-12-31T00:58:25.064+00:00",
  },
  {
    _id: "67853d09795aa4d52cd6061c",
    title: "HTML",
    proficiency: "intermediate",
    description:
      "Standard markup language for structuring content and layouts on the web.",
    images:
      "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/html5/html5-original.svg",
    category: "Frontend",
    createdAt: "2025-01-13T16:19:21.595+00:00",
    updatedAt: "2025-01-13T16:19:21.595+00:00",
  },
  {
    _id: "67868a8ddc63840a3946245d",
    title: "Python",
    proficiency: "intermediate",
    description:
      "High-level programming language known for readability and versatility across domains.",
    images: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/python/python-original-wordmark.svg",
    category: "Backend",
    createdAt: "2025-01-14T16:02:21.748+00:00",
    updatedAt: "2025-01-14T16:02:21.748+00:00",
  },
];
